module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_11_39_353Z.31cd4fd9.png";